export function defaultPad() {
  return { mint: null, trades: [], page: 1, position: null }
}

export function normalizePad(raw) {
  if (!raw || typeof raw !== 'object') return defaultPad()

  let page = Number(raw.page ?? 1)
  if (!Number.isFinite(page) || page < 1) page = 1

  return {
    mint: typeof raw.mint === 'string' ? raw.mint : null,
    trades: Array.isArray(raw.trades) ? raw.trades : [],
    page,
    position: raw.position && typeof raw.position === 'object' ? raw.position : null,
  }
}
